import ReactDOM from 'react-dom/client';
import App from './App';
import { store } from './redux/store';
import { Provider } from 'react-redux';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { AddBearerToken, Initialise } from './helpers/api/axiosService';
import { getToken } from './helpers/api/authService';

//Init Axios
Initialise();

AddBearerToken(getToken());

const rootElement = document.getElementById("root")!;
const root = ReactDOM.createRoot(rootElement);

if(!window.location.href.includes("https") && !window.location.href.includes("localhost")){   
    window.location.replace(window.location.href.replace("http","https"));
}

// render the App component inside it
root.render(
    <Provider store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </Provider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
